'use client';

import React, { useState } from 'react';
import { Footer, Hero, GetStarted } from '../../../components';
import styles from './contact.module.css';
import { spinner } from '../../../utils';
import { useContactFormList } from '../../../lib/util/index';
import toast from 'react-hot-toast';

const ContactUs = () => {
  const initialFormState = {
    firstname: '',
    lastname: '',
    email: '',
    message: '',
  };
  const [formInput, setFormInput] = useState(initialFormState);

  const { isLoading, mutate, isSuccess, isError, data, error } = useContactFormList({
    onSuccess: () => {
      toast.success('Thank you! We will get back to you shortly.');
      setFormInput(initialFormState);
    },
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormInput({
      ...formInput,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    mutate(formInput);
  };

  const btnDisabled = !formInput.email || !formInput.firstname || !formInput.lastname || !formInput.message;

  return (
    <div className={styles.contactcontainer}>
      <div className={styles.hero_form}>
        <Hero>
          <button className={styles.herobtn}>Say Hello👋</button>
          <p className={styles.herotitle}>Contact Us</p>
          <p className={styles.herodescription}>
            Find the perfect fit for your needs with our adaptable plans and pricing options.
          </p>
        </Hero>
        <div className={styles.formcontainer}>
          <div className={styles.formwrapper}>
            <form className={styles.contactform} onSubmit={handleSubmit}>
              <div className={styles.formelements}>
                <div className={styles.formelement_names}>
                  <div className={styles.formnamefield}>
                    <label htmlFor="firstname" className={styles.formlabel}>
                      First Name
                    </label>
                    <input
                      type="text"
                      name="firstname"
                      placeholder="Enter first name"
                      className={styles.formInput}
                      value={formInput.firstname}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className={styles.formnamefield}>
                    <label htmlFor="firstname" className={styles.formlabel}>
                      Last Name
                    </label>
                    <input
                      type="text"
                      name="lastname"
                      placeholder="Enter last name"
                      className={styles.formInput}
                      value={formInput.lastname}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className={styles.formelement}>
                  <label htmlFor="email" className={styles.formlabel}>
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter email"
                    className={styles.formInput}
                    value={formInput.email}
                    onChange={handleInputChange}
                  />
                </div>
                <div className={styles.formelement}>
                  <label htmlFor="message" className={styles.formlabel}>
                    Message
                  </label>
                  <textarea
                    name="message"
                    id=""
                    cols="30"
                    rows="10"
                    placeholder="Enter your request"
                    className={styles.formMessageInput}
                    value={formInput.message}
                    onChange={handleInputChange}
                  ></textarea>
                </div>
              </div>
              <button
                className={btnDisabled ? `${styles.btnDisabled} ${styles.formbtn}` : styles.formbtn}
                disabled={btnDisabled}
              >
                {isLoading ? spinner : 'get in touch'}
              </button>
            </form>
          </div>
        </div>
        <div>
          <GetStarted />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactUs;
